import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  selectedAppsBS:BehaviorSubject<any>=new BehaviorSubject({});
  selectedApp:any;
  constructor() { }
}
